import React from 'react';
import { Route } from 'react-router';
import OmniSearchResponsive from '@app/components/presentational/OmniSearchResponsive';
import OverlayLoader from '../components/containers/OverlayLoader';
import UserBar from '../components/presentational/Navigation/UserBarToggle';
import { getCurrentUser } from '@core/utils/currentUser';
import { fetchInitialData, fetchAndSetFeatures } from './Dashboard';
import { getStore } from '../store';
import * as navigationActions from '../actions/navigation';
import { getCurrentSpaceId } from '@core/selectors/space/space.selectors';
import { getInitialSpaceId } from '@core/selectors/space/space.selectors';

const getOnSearchEnter =
  (queryClient, ldClient) => async (nextState, replace) => {
    if (!getCurrentUser()) {
      replace({
        pathname: '/logout',
        state: { nextPathname: nextState.location.pathname },
      });
      return;
    }

    await fetchInitialData(queryClient);

    if (!ldClient) return;

    const { dispatch, getState } = getStore();
    const state = getState();

    // Get current space ID or initial space ID for feature flags
    // This ensures we have a space to fetch feature flags even if no classId in URL
    const currentSpaceId = getCurrentSpaceId(state) || getInitialSpaceId(state);

    if (!currentSpaceId) {
      dispatch(() => fetchAndSetFeatures(state, dispatch, ldClient, undefined));
      return;
    }

    // Load the space to ensure store is properly initialized and fetch feature flags
    await dispatch(
      navigationActions.decideAndLoadClassRoom(
        currentSpaceId,
        nextState.location.search,
        (spaceId) => fetchAndSetFeatures(state, dispatch, ldClient, spaceId)
      )
    );
  };

const SearchRoute = (queryClient, ldClient) => {
  return (
    <Route
      path="search"
      components={{
        overlayLoader: OverlayLoader,
        userBar: UserBar,
        content: OmniSearchResponsive,
      }}
      onEnter={getOnSearchEnter(queryClient, ldClient)}
    />
  );
};

export default SearchRoute;
